import { createStore, Store, StoreEnhancer } from 'redux';
import reducers from './reducers';
import { StoreState } from './reducers/namecheck/namecheck.interface';

export default (initialState?: StoreEnhancer<StoreState>): Store => {
  const store = createStore(reducers, initialState);

  return store;
};
